<div class="container">
    <mat-table matSort [dataSource]="dataSource" background="#15151c" class="partner-table" multiTemplateDataRows>

        <ng-container matColumnDef="name">
            <mat-header-cell *matHeaderCellDef mat-sort-header> PARTNER <app-sort-arrows-icon [direction]="getSortDirection('name')" class="sort-arrows"></app-sort-arrows-icon> </mat-header-cell>
            <mat-cell *matCellDef="let element"> {{element.name}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="earningsYtd">
            <mat-header-cell *matHeaderCellDef mat-sort-header (click)="sortByEarnings()"> EARNINGS YTD <app-sort-arrows-icon [direction]="getSortDirection('earningsYtd')" class="sort-arrows"></app-sort-arrows-icon></mat-header-cell>
            <mat-cell *matCellDef="let element"> ${{element.earningsYTD}} </mat-cell>
        </ng-container>        

        <ng-container matColumnDef="proStatus">
            <mat-header-cell *matHeaderCellDef mat-sort-header (click)="sortByProStatus()"> PRO STATUS <app-sort-arrows-icon [direction]="getSortDirection('proStatus')" class="sort-arrows"></app-sort-arrows-icon></mat-header-cell>
            <mat-cell *matCellDef="let element"><app-status-dot-icon class="status-icon" [status]="element.proStatus" [matTooltip]="element.proStatus" matTooltipPosition="left" matTooltipClass="tooltip-white"></app-status-dot-icon> <span>{{element.proStatus}}</span> </mat-cell>
        </ng-container>

        <ng-container matColumnDef="action">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let row"> 

                <button>
                    <app-drop-down-arrow (click)="navigateToDetails(row)" [pointRight]="true" [stroke]="'#50e3c2'"></app-drop-down-arrow>
                </button>

            </mat-cell>
        </ng-container>


        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>
</div>